import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';

import { BadgeList } from '../../../../../../../common/components/BadgeList';
import { useWidget } from '../../../../../../../contexts/widgets';
import {
  badgesAlignmentMap,
  ProfileAlignment,
} from '../../../../../../../types';
import styles from './Badges.scss';

export const Badges: FC = () => {
  const { isRTL } = useEnvironment();
  const { i18n } = useTranslation();
  const { site, computed, handlers } = useWidget();

  const { navigateToViewedMember } = handlers;
  const { badgesSettings, profileAlignment } = computed;
  const { isSocial } = site;

  const isRightAlignment =
    profileAlignment === ProfileAlignment.Right && !isRTL;
  const isCenterAlignment = profileAlignment === ProfileAlignment.Center;
  const badgesAlignment = badgesAlignmentMap[profileAlignment];

  return (
    <div
      className={classNames({
        [styles.container]: true,
        [styles.isRightAlignment]: isRightAlignment,
        [styles.isCenterAlignment]: isCenterAlignment,
      })}
    >
      <BadgeList
        {...badgesSettings}
        align={badgesAlignment}
        maxRows={1}
        onClickMore={isSocial ? navigateToViewedMember : undefined}
        onBadgeClick={isSocial ? navigateToViewedMember : undefined}
        i18n={i18n}
      />
    </div>
  );
};
